
  import { gmapApi } from 'vue2-google-maps';
  import * as geolib from 'geolib';

  import UMUM from '../library/umum'
  
  export default {
    data() {
      return {
        UMUM : UMUM,
        url: {
          GET_URL: "https://server-sita.konaweselatankab.go.id/api/v1/peta_dasar/"
        },
        petadasar: [],
        list_stunting: [],
        kecamatan : [],
        desa : [],
        jumlah_kasus : '',
        jumlah_jkn : '',
        jumlah_jamban : '',
        jumlah_air : '',
        jumlah_kec : '',
        jkn_kec : '',
        jamban_kec : '',
        air_kec : '',
        jumlah_desa : '',
        jkn_desa : '',
        jamban_desa : '',
        air_desa : '',
        mdl_lihat : false,
        kecamatan_id: null,
        des_kel_id: null,
        hasil: {
          id: '',
          nama_desa: '',
          nama_kecamatan: '',
          kode_kecamatan: '',
          kode_desa: '',
          coordinat: [],
        },
        clusterOptions: {
          gridSize: 30,
          maxZoom: 15,
        },
        currentLocation: {
          lat: 0,
          lng: 0,
        },
        polygonZonaOptions: {
          fillColor: 'green',
          fillOpacity: 0.5,
          strokeOpacity: 1,
          strokeWeight: 1,
          // Opsi warna dan kecerahan arsiran polygon
        },
        polygonZonaOptionsModal: {
          fillColor: 'blue',
          fillOpacity: 0.3,
          strokeOpacity: 1,
          strokeWeight: 1,
          // Opsi warna dan kecerahan arsiran polygon
        },
        locationAccuracy: null, // Properti untuk menyimpan akurasi lokasi
        infoWindowPosition: null, // Position of the InfoWindow
        infoWindowOpened: false,  // Whether InfoWindow is open
      }
    },
    methods: {

      onInput() {
      this.getDesa()
      this.getPetadasar()
    },

      getPetadasar: function () {
        this.cek_load_data = true;
        fetch(this.url.GET_URL + "petastunting", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            kecamatan_id : this.kecamatan_id,
            des_kel_id : this.des_kel_id,
          })
        })
        .then(res => res.json())
        .then(res_data => {
          this.petadasar = res_data;
        });
      },

      showInfoWindow(event) {
      // Set the position of the InfoWindow to the clicked point
      // this.infoWindowPosition = event.latLng;
      // Set the content of the InfoWindow (can be dynamic)
      // this.polygonInfo = "You clicked on a polygon!";
      // Open the InfoWindow
      this.infoWindowOpened = true;
    },

      getDataStunting : function(){            
            fetch(this.$store.state.url.URL_STUNT + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    kode_desa : this.hasil.kode_desa,
                    kode_kecamatan : this.hasil.kode_kecamatan,
                })
            })
                .then(res => res.json())
                .then(res_data => {

                  console.log(res_data);
                  
                    
                    this.list_stunting = res_data.data;
                    this.jumlah_kasus = res_data.data[0].jumlah_data;
                    this.jumlah_jkn = res_data.data[0].jumlah_jkn;
                    this.jumlah_jamban = res_data.data[0].jumlah_jamban;
                    this.jumlah_air = res_data.data[0].jumlah_air;
                    this.jumlah_kec = res_data.data[0].jumlah_kec;
                    this.jkn_kec = res_data.data[0].jkn_kec;
                    this.jamban_kec = res_data.data[0].jamban_kec;
                    this.air_kec = res_data.data[0].air_kec;
                    this.jumlah_desa = res_data.data[0].jumlah_desa;
                    this.jkn_desa = res_data.data[0].jkn_desa;
                    this.jamban_desa = res_data.data[0].jamban_desa;
                    this.air_desa = res_data.data[0].air_desa;
            });
        },

      getKecamatan : function(){            
            fetch(this.$store.state.url.URL_STUNT + "kec_stunt", {
                method: "GET",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
            })
                .then(res => res.json())
                .then(res_data => {
                console.log(res_data);
                this.kecamatan = res_data.data;
            });
        },

      getDesa : function(){            
            fetch(this.$store.state.url.URL_STUNT + "desa_stunt", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                  kecamatan_id : this.kecamatan_id,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                console.log(res_data);
                this.desa = res_data.data;
            });
        },

      calculatePolygonCentroid(data) {
        const totalLat = data.reduce((sum, point) => sum + point.lat, 0);
        const totalLng = data.reduce((sum, point) => sum + point.lng, 0);
        const avgLat = totalLat / data.length;
        const avgLng = totalLng / data.length;

        var hasil = {
          lat: avgLat,
          lng: avgLng,
        };


        return hasil;
      },

      Notify_marker : function(message){
        this.$q.notify({
          progress: true,
          message: message,
          color: 'success',
          avatar: 'https://cdn.quasar.dev/img/boy-avatar.png',
          position : 'top',
          actions: [
            { label: 'Keluar', color: 'yellow', handler: () => { /* ... */ } }
          ],
          timeout: 10000,
        })
      },

      selectDataPetaDasar: function (data) {
        console.log(data);
        this.hasil = {
          id: data.id,
          nama_desa: data.nama_desa,
          nama_kecamatan: data.nama_kecamatan,
          kode_kecamatan: data.kode_kecamatan,
          kode_desa: data.kode_desa,
          coordinat: data.coordinat,
        };
      },

        // LIVE LOCATION
      onLocationSuccess(position) {
        // Mendapatkan koordinat lokasi terkini

        // console.log("posisi ", position);

        this.currentLocation.lat = position.coords.latitude;
        this.currentLocation.lng = position.coords.longitude;

        // Mendapatkan akurasi lokasi dan menyimpannya dalam properti locationAccuracy
        this.locationAccuracy = position.coords.accuracy;

      },
      onLocationError(error) {
        console.error('Gagal mendapatkan lokasi terkini:', error);
      },
      showLocationInfo() {
        // Tambahkan logika untuk menampilkan informasi lokasi di sini
      },

      startBounceAnimation() {
        this.markerOptions.animation = google.maps.Animation.BOUNCE;
      },
      stopBounceAnimation() {
        this.markerOptions.animation = null;
      },

    },
  
    computed: {
      google: gmapApi
    },

    mounted() {
      this.getPetadasar()
      this.getKecamatan()
    },
  }
